import * as React from "react"
import useLazyTimeout from "@digits-shared/hooks/useLazyTimeout"
import useStateBoolean from "@digits-shared/hooks/useStateBoolean"

export function useDisableFor(delayMs: number) {
  const { value: disabled, setTrue: disable, setFalse: enable } = useStateBoolean()
  const [enableAfterDelay] = useLazyTimeout(enable, delayMs)
  const disableForDuration = React.useCallback(() => {
    disable()
    enableAfterDelay()
  }, [disable, enableAfterDelay])

  return React.useMemo(
    () => ({
      disabled,
      disableForDuration,
      disable,
      enable,
    }),
    [disabled, disableForDuration, disable, enable]
  )
}
